import {defineMessages, FormattedMessage} from 'react-intl';

import {Link, view} from '@sail/ui';

import {useTheme} from '@stripe-internal/conversations-ui';

import {RequestACallVerificationCodeEndpointResponseClientError} from '../../../../generated/types';

const messages = defineMessages({
  genericVerificationCodesError: {
    id: 'conversations_assistant.support_conversations_client.rac.confirmation.genericVerificationCodesError',
    description:
      'Error message when loading support verification codes telling user to refresh the page',
    defaultMessage:
      'Something went wrong. Please refresh the page to verify your phone call.',
  },
  loginErrorMessage: {
    id: 'conversations_assistant.support_conversations_client.rac.confirmation.loginVerificationCodesError',
    description: 'Error message indicating the user needs to login',
    defaultMessage: 'Please sign in to verify your phone call.',
  },
});

type Props = {
  clientError?: RequestACallVerificationCodeEndpointResponseClientError;
  serverError?: boolean;
};

export function RACError({clientError, serverError}: Props) {
  const theme = useTheme();
  if (!clientError && !serverError) {
    return null;
  }

  let errorMessage;

  if (clientError?.type === 'unauthorized') {
    errorMessage = <FormattedMessage {...messages.loginErrorMessage} />;
  } else {
    errorMessage = (
      <FormattedMessage {...messages.genericVerificationCodesError} />
    );
  }

  if (clientError?.signInUrl) {
    return (
      <Link
        href={clientError.signInUrl}
        target="_top"
        css={{
          color: theme.linkColor,
        }}
      >
        {errorMessage}
      </Link>
    );
  } else {
    return <view.span css={{font: 'body.small'}}>{errorMessage}</view.span>;
  }
}
